module.exports = __webpack_public_path__ + "static/media/DashboardImage.7be22aac.jpg";